export default "__VITE_ASSET__BjoLCpzm__"